export const EMAIL_REGEX_PATTERN =
  // eslint-disable-next-line sonarjs/slow-regex,sonarjs/regex-complexity
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/

export const PHONE_REGEX_PATTERN = /^[^a-zA-Z]{6,20}$/
export const LOCALE_REGEX_PATTERN = /^[a-z]{2}-[a-zA-Z]{2}$/
